<section class="fullWidthCls locationPgParentCls">
  <div class="locationSec">
    <div class="mapContainer">
      <agm-map #gm class="cusWindowRefCls" [latitude]="scheduleExamLocationModel.mapCenterLat" (mapClick)="gm.lastOpen?.close();"
        [longitude]="scheduleExamLocationModel.mapCenterLng">
        <agm-marker class="cusWindowRefCls1" iconUrl='./assets/images/cLocMarkerBubble.png' [latitude]="scheduleExamLocationModel.cLocLat"
          [longitude]="scheduleExamLocationModel.cLocLng" title="your current location">
        </agm-marker>
        <agm-marker class="cusWindowRefCls1" *ngFor="let location of scheduleExamLocationModel.examLocations; let i = index;" iconUrl='assets/images/markerBubble.gif'
          [latitude]="location.latitude" [longitude]="location.longitude" label="" (markerClick)="openMarkerWindow(infoWindow);">
          <agm-info-window #infoWindow>
            <div class="centerLocationInfo">
              <ul class="centerLocInfoDetail">
                <!-- Time Zone -->
                <li>
                  <a mdTooltip="{{ location.timeZone }}" href="javascript:void(0);">
                    <img src="./assets/images/timeZone_icon.png" />
                  </a>
                </li>
                <!-- Keyboard Type -->
                <li>
                  <a mdTooltip="{{ location.keyboardType }}" href="javascript:void(0);">
                    <img mdTooltip="{{ location.keyboardType }}" alt="{{ location.keyboardType }}" src="./assets/images/keyboard_icon.png" />
                  </a>
                </li>
                <!-- Operational Hours -->
                <li>
                  <a mdTooltip="{{ _utility.getOperationalHours(location.locationTimeDetails) }}" href="javascript:void(0);">
                    <img src="./assets/images/operationalHours_icon.png" />
                  </a>
                </li>
              </ul>
              <p class="centerLocationNameSec">
                <strong class="locationNameTitleCls">{{ location.code }}</strong>
              </p>
              <!-- <p class="centerLocAddressInfo" mdTooltip="{{ location.streetAddress + ', '+ location.city +', '+ location.state +', '+ location.country }}"> -->
              <p class="centerLocAddressInfo">
                <span>
                  <i class="material-icons">&#xE8B4;</i>
                </span> {{ _utility.getShortStr(location.streetAddress + ', '+ location.city +', '+ location.state +', '+ location.country,100)
                }}
              </p>
              <span (click)="proceedToSchedule(location)" class="centerLocCalIcon">
                <a mdTooltip="Schedule Exam" href="javascript:void(0);">
                  <img src="./assets/images/centerLocDetIcon.png" />
                </a>
              </span>
            </div>
          </agm-info-window>
        </agm-marker>
      </agm-map>
    </div>
    <div class="searchLocationCls" (click)="_utility.toggle_class()">
      <form class="searchLocation-form">
        <md-input-container class="searchTxtCls" floatPlaceholder="never">
          <input mdInput type="text" minlength="3" maxlength="200" name="txtSearch" (keydown)="handleKeyDown($event)" placeholder="Search Location by Country"
            #ctrl="ngModel" [(ngModel)]="scheduleExamLocationModel.searchStr">
          <md-icon (click)="callSearchLocations()" class="srchIconCls" mdSuffix>mode_search</md-icon>
          <a class="myLocation" href="javascript:void(0);" (click)="getCurrentLocation(false)">
            <img src="./assets/images/myLocationIcon.png" />
          </a>
        </md-input-container>
      </form>
      <div *ngIf="scheduleExamLocationModel.pageLoad==false && (scheduleExamLocationModel.examLocations==null || scheduleExamLocationModel.examLocations==[] || scheduleExamLocationModel.examLocations.length<=0)"
        class="resultNotFoundSec">
        No Results Found
      </div>
      <div *ngIf="scheduleExamLocationModel.examLocations.length>0" class="resultListSec" id="resultListSecB">
        <perfect-scrollbar #locationScroll>
          <div *ngFor="let location of scheduleExamLocationModel.examLocations;let i = index" [class]="(i==scheduleExamLocationModel.examLocations.length-1?'searchListNoBorder ':'') + (i%2==0?'searchListEven':'searchListOdd')">
            <a href="javascript:void(0);">
              <div class="searchListContent" (click)="highlightAddress(location)">
                <ul>
                  <!-- TimeZone -->
                  <li mdTooltip="{{ location.timeZone }}">
                    <a href="javascript:void(0);">
                      <img src="./assets/images/timeZone_icon.png" />
                    </a>
                  </li>
                  <!-- Keyboardtype -->
                  <li mdTooltip="{{ location.keyboardType }} ">
                    <a href="javascript:void(0);">
                      <img src="./assets/images/keyboard_icon.png" />
                    </a>
                  </li>
                  <!-- Operational Hours -->
                  <li mdTooltip="{{ _utility.getOperationalHours(location.locationTimeDetails) }} ">
                    <a href="javascript:void(0);">
                      <img src="./assets/images/operationalHours_icon.png" />
                    </a>
                  </li>
                </ul>
                <p>
                  <strong>{{ location.code }}</strong>
                  <br/>
                  <strong>Address: </strong> {{ location.streetAddress }}
                  <br/>{{ location.city }},&nbsp;{{ location.state }},&nbsp;{{ location.country }} </p>
                <div (click)="proceedToSchedule(location)" class="schExamSrchCls">
                  <img src="./assets/images/exams-schedule.png" />
                  <a href="javascript:void(0)">Schedule Exam</a>
                </div>
              </div>
            </a>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/schedule-exam-location/schedule-exam-location.component.html